<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>ERP/CMS</h2>
        </div>
    </div>
</div>

<div class="service-details ptb-100">
    <div class="container">
        <div class="service-details-content">
            <div class="row">
                <div class="col-lg-5 col-md-6 col-sm-12 col-12">
                    <div class="service-details-image">
                        <img src="assets/img/services-image/service_4.jpeg" class="w-100" alt="image">
                    </div>
                </div>
                <div class="col-lg-7 col-md-6 col-sm-12 col-12">
                    <h3>ERP/CMS Development</h3>
                    <p>
                        At Kaims IT Services, we facilitate your transition into digital transformation by comprehending
                        your current processes and addressing your's challenges. We recommend ERP/CMS software to
                        maximize gains, offering not just solutions but also essential training for efficient usage.
                    </p>
                    <p>
                        CMS, CRM, and ERP are the three main software solutions to automate core processes in business.
                        They assist in managing day-to-day operations, the company’s interactions with customers,
                        handling data, reducing redundant tasks, prioritizing leads, running a website, and much more.
                        CMS, CRM, and ERP offer powerful tools to boost profitability and increase sales. However, the
                        core components and the work principles are not the same, especially regarding CMS.
                    </p>
                    <p>
                        Kaims IT Services, an Epicor Silver Partner and CMS Managed Services Provider, has years
                        of experience hosting and managing CMS production and system backup environments, as well as
                        over 10 years of history interacting with and supporting the CMS ERP application environments,
                        including EDI, eBusiness and MES solutions.
                    </p>

                    <p>
                        We welcome you to review our portfolio of CMS specific solution offerings, ranging from
                        application support and development services, to full blown system management and hosting
                        managed services for your production or backup CMS environments.
                    </p>

                    <p>
                        We are more than just a CMS Service Provider. We are your Technology Partner.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="features-card-section pt-100 pb-70 bg-f8fbfa">
    <div class="container">
        <div class="row mb-5">
            <div class="col-lg-12 col-sm-12 text-center">
                <div class="icon mb-4">
                    <img src="assets/img/favicon.png" class="fav-size" alt="image">
                </div>
                <h2 class="mb-4">
                    <strong>Technology We Use</strong>
                </h2>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxs-cog'></i>
                    <h3><a>ERP</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxs-cog'></i>
                    <h3><a>CMS</a></h3>
                </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-md-6">
                <div class="single-features-card tx-center">
                    <i class='bx bxs-cog'></i>
                    <h3><a>CRM</a></h3>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <section class="subscribe-area bg-f4f5fe">
    <div class="container">
        <div class="subscribe-content">
            <h2>We always try to be the best support to you as possible</h2>
            <form class="newsletter-form">
                <div class="row align-items-center">
                    <div class="col-lg-8 col-md-8">
                        <input type="email" class="input-newsletter" placeholder="hello&#64;jexsa.com" name="EMAIL"
                            required>
                    </div>
                    <div class="col-lg-4 col-md-4">
                        <button type="submit"><i class="bx bxs-hot"></i> Subscribe Now</button>
                    </div>
                </div>
            </form>
            <div class="shape14"><img src="assets/img/shape/shape13.png" alt="image"></div>
            <div class="shape15"><img src="assets/img/shape/shape14.png" alt="image"></div>
            <div class="shape16"><img src="assets/img/shape/shape15.png" alt="image"></div>
            <div class="shape17"><img src="assets/img/shape/shape16.png" alt="image"></div>
            <div class="shape18"><img src="assets/img/shape/shape17.png" alt="image"></div>
        </div>
    </div>
</section> -->

<section class="free-trial-area ptb-100 bg-f4f5fe">
    <div class="container">
        <div class="free-trial-content">
            <h2>We always try to be the best support to you as possible</h2>
            <p>Qualify your leads & recognize the value of word your customer will love you</p>
            <a routerLink="/contact" class="default-btn"><i class="bx bxs-hot"></i> Contact Us<span></span></a>
        </div>
    </div>
    <div class="shape10"><img src="assets/img/shape/shape10.png" alt="image"></div>
    <div class="shape11"><img src="assets/img/shape/shape7.png" alt="image"></div>
    <div class="shape12"><img src="assets/img/shape/shape11.png" alt="image"></div>
    <div class="shape13"><img src="assets/img/shape/shape12.png" alt="image"></div>
</section>